var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="customDivWaiting">   <div class="container"> <div style="height:20px"></div> <div id="searchEventQuery"></div> <div style="height:20px"></div> <div id="searchEventList"></div> <div style="height:20px"></div> <div class="row"> <div id="main-col" class="col-sm-12 col-md-12"> <div id="searchEventPagination" style="text-align:center"></div> </div> <div class="col-md-12 col-sm-12 col-sm-12"> <div class="col-md-12 col-sm-12 col-sm-12" id="searchEventInformation"></div> </div> </div> </div> </div>  ';
}
return __p;
};
